import { render, staticRenderFns } from "./sample-order-form-component.vue?vue&type=template&id=035f2145&scoped=true"
import script from "./sample-order-form-component.vue?vue&type=script&lang=js"
export * from "./sample-order-form-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035f2145",
  null
  
)

export default component.exports